// extracted by mini-css-extract-plugin
export default {"TitleTextButtonContainer":"TitleTextButton_TitleTextButtonContainer__XQK+5","Title":"TitleTextButton_Title__-pa+n","Text":"TitleTextButton_Text__KXfZI"};